export const FORM_NAME = 'confirmYourVehicle'
